<template>
  <a-layout class="materials">
    <a-layout-header class="materials__header">
      <a-row class="materials__row">
        <a-col :span="12" class="materials__col">
          <a-input-search
            size="large"
            placeholder="criar novo grupo"
            v-model="similarGroupName"
            @search="create()"
          >
            <a-button type="primary" icon="plus" slot="enterButton">
              criar
            </a-button>
          </a-input-search>
          <ul class="materials__hint">
            <li>
              Os grupos de materiais são agrupamentos de entidades semelhantes
            </li>
            <li>Evite ao máximo criar novos grupos</li>
            <li>Faça isso apenas se for extremamente necessário</li>
          </ul>
        </a-col>
        <a-col :span="12" class="materials__col" style="padding-left: 6px;">
          <a-input-search
            size="large"
            placeholder="adicionar material em um grupo"
            v-model="materialToAddToGroup"
            @search="addToGroup"
          >
            <a-button type="danger" icon="plus" slot="enterButton">
              adicionar
            </a-button>
          </a-input-search>
          <ul class="materials__hint">
            <li>
              Preencha o slug material ou nome do device e adicione ele a um
              grupo
            </li>
            <li>Um material/device não pode estar em mais de um grupo</li>
            <li>
              Adicione o slug do material completo, mesmo que seja case
            </li>
          </ul>
        </a-col>
      </a-row>
    </a-layout-header>

    <a-layout-content class="materials__content">
      <similar-group
        v-for="(item, index) in groups"
        :key="index"
        :group="item"
        @change="init"
      >
        <template v-slot:device="{ device }">
          <a-card v-if="findMaterial(device)" :title="device">
            <template slot="extra">
              <a-popover title="Alert">
                <template slot="content">
                  <p>
                    Remove <b>{{ device }}</b> from group
                    <b>{{ item.name }}</b>
                  </p>
                </template>
                <a-button
                  type="link"
                  icon="delete"
                  size="small"
                  @click="handleMenuClick({ key: item.identifier }, device)"
                />
              </a-popover>
            </template>
            <mockup-preview
              class="mockup-preview"
              :material="findMaterial(device)"
              :stamps="[item.stamp]"
            />
          </a-card>
        </template>
      </similar-group>
    </a-layout-content>

    <a-modal
      title="Escolha o grupo de materiais"
      :visible="addMaterialToGroupModal"
      width="60%"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="group" v-if="addMaterialToGroupModal">
        <div
          v-for="item in groups"
          :key="item.id"
          class="items"
          :class="{
            'items--active': currentGroupOfCurrentMaterial === item,
          }"
          @click="currentGroupOfCurrentMaterial = item"
        >
          <p class="group__title">
            {{ item.name }}
          </p>
          <mockup-preview
            :material="findMaterial(materialToAddToGroup)"
            :stamps="[item.stamp]"
          />
        </div>
      </div>
    </a-modal>
  </a-layout>
</template>

<script>
import SimilarGroup from "@/components/similar-group/SimilarGroup.vue";
import MockupPreview from "@/components/mockup-preview/MockupPreview.vue";
import { getCaseDevices } from "@/api/factory-api/case-device-api/caseDevice.api.js";
import { getMaterialFromFactory } from "@/api/factory-api/material-api/material.api.js";
import {
  getSimilarGroup,
  setSimilarGroup,
} from "@/api/catalog-api/similar-group-api/similarGroup.api.js";

export default {
  components: { SimilarGroup, MockupPreview },
  data() {
    return {
      groups: null,
      similarGroupName: null,
      materials: null,
      devices: null,
      addMaterialToGroupModal: false,
      materialToAddToGroup: null,
      currentGroupOfCurrentMaterial: null,
      caseTypes: null,
    };
  },
  mounted() {
    getCaseDevices().then((res) => {
      this.caseTypes = res.case_types;
      this.materials = res.materials;
      this.devices = res.devices;
    });
    this.init();
  },
  methods: {
    findMaterial(device) {
      const { availableMaterial } = this;

      if (device.includes("iphone14")) {
        const caseTypes = [
          "casedeluxeslimfosco",
          "casedeluxeslimfosco",
          "caseduopb",
          "duorosatransparente",
          "newecodeluxegocustomized",
          "casedeluxeslimpreto",
        ];

        let math = caseTypes.find((caseType) =>
          availableMaterial(`${caseType}-${device}`)
        );

        if (math) return `${math}-${device}`;
      }

      if (availableMaterial(`standard-${device}`)) return `standard-${device}`;
      else if (availableMaterial(`standardinvition-${device}`))
        return `standardinvition-${device}`;
      else if (availableMaterial(`caseimpactslimstandard-${device}`))
        return `caseimpactslimstandard-${device}`;
      else if (availableMaterial(`deluxe-${device}`)) return `deluxe-${device}`;
      else if (availableMaterial(`standardgocustomized-${device}`))
        return `standardgocustomized-${device}`;
      else if (availableMaterial(`deluxemattegocustomized-${device}`))
        return `deluxemattegocustomized-${device}`;
      else return device;
    },
    availableMaterial(material) {
      return !this.materials || this.materials.includes(material);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    inGroup(group, device) {
      const temp = group.devices.find((d) => d === device);
      if (!temp) return false;
      return group;
    },
    init() {
      this.groups = null;
      return getSimilarGroup().then((res) => (this.groups = res.groups));
    },
    create() {
      const group = {
        name: this.similarGroupName,
        identifier: this.similarGroupName.replace(/[^a-z0-9]/gi, "-"),
      };
      return setSimilarGroup(group).then((res) => this.init());
    },
    async addToGroup() {
      let ok;
      await getMaterialFromFactory(this.materialToAddToGroup)
        .then(() => (ok = true))
        .catch(() => (ok = false));
      if (!ok) {
        alert(
          "o material não está cadastrado no factory" +
            ", por favor verifique o slug de material" +
            " e as informações cadastradas no material no factory" +
            " caso existam."
        );
        return;
      }
      this.addMaterialToGroupModal = true;
    },
    handleOk() {
      let hasCaseType = this.caseTypes.find((el) =>
        this.materialToAddToGroup.includes(el)
      );

      if (
        hasCaseType &&
        !this.materialToAddToGroup.match("garrafa") &&
        !this.materialToAddToGroup.match("lancheira")
      ) {
        this.materialToAddToGroup = this.materialToAddToGroup.split("-")[1];
      }

      let hasGroup = this.groups.find((g) =>
        g.devices.find((d) => d === this.materialToAddToGroup)
      );

      if (hasGroup) {
        let msg = "";
        if (
          hasGroup.identifier === this.currentGroupOfCurrentMaterial.identifier
        )
          msg = "O material já está nesse grupo";
        else
          msg =
            "o material informado já está no grupo " +
            hasGroup.name +
            "! para adiciona-lo em " +
            this.currentGroupOfCurrentMaterial.name +
            " remova-o do " +
            hasGroup.name +
            " e tente novamente!";

        alert(msg);
        return;
      }

      this.handleMenuClick(
        {
          key: this.currentGroupOfCurrentMaterial.identifier,
        },
        this.materialToAddToGroup
      );
    },
    handleMenuClick(e, device) {
      const { key } = e;
      const group = this.groups.find((g) => g.identifier === key);
      if (!device) return false;
      if (this.inGroup(group, device)) {
        const r = confirm("Esse device já está nesse grupo, deseja remover?");
        if (r) group.devices = group.devices.filter((d) => d !== device);
        else return false;
      } else {
        group.devices.push(device);
      }
      return setSimilarGroup(group).then(() => this.init());
    },
    handleCancel() {
      this.addMaterialToGroupModal = false;
      this.materialToAddToGroup = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.materials {
  .materials__header {
    background: $white;
    height: 130px;
  }

  .materials__row,
  .materials__col {
    display: flex;
    align-items: center;
  }

  .materials__hint {
    line-height: 14px;
    padding: 10px 0 0 20px;
  }

  .materials__col {
    flex-direction: column;
    align-items: flex-start;
  }

  .materials__row {
    height: 100%;
  }

  .materials__content {
    padding: 12px;
  }
}

.mockup-preview {
  width: 200px;
}

.select {
  width: 100%;
}

.group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  &__title {
    max-width: 20ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.items {
  margin: 9px;
  border: 2px solid;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;

  &--active {
    border-color: cornflowerblue;
  }

  &:hover {
    border-color: cyan;
  }
}
</style>
